/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-09T17:19:06.603
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'report-reportrentcontract-'

export default 
{
path: '/report/reportrentcontract',
name: 'report-reportrentcontract',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}reportrentcontract-index',

meta:{
...meta,
title: '出租管理'
},

component: () => import('@/pages/report/reportrentcontract/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}reportrentcontract-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '出租管理编辑'
},

component: () => import('@/pages/report/reportrentcontract/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}reportrentcontractdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '出租管理新增'
},

component: () => import('@/pages/report/reportrentcontract/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}reportrentcontractView',
auth: [
'hidden'
],

meta:{
...meta,
title: '出租管理详情查看'
},

component: () => import('@/pages/report/reportrentcontract/detail-view') ,
},
]
};
